<script lang="ts">
import { inject } from 'vue'
import Legend from 'ol-ext/legend/Legend'
import LegendControl from 'ol-ext/control/Legend'
import LegendImage from 'ol-ext/legend/Image'
import type Map from 'ol/Map.js'

export default {
    name: 'DkOlLegend',
    components: {},
    props: {
        legendCollapsed : { type: Boolean, required: false, default: true },
    },
    data() {
        return {
            legend: null as Legend,
            legend2: null as Legend,
            // drawer: false,
        }
    },
    computed: {
    },
    mounted() {
        const map: Map = inject('map')

        const legend = this.legend = new Legend({
            title: 'Légende',
            margin: 10,
            maxWidth: 400,
        })

        const legendCtrl = new LegendControl({
            legend,
            collapsed: this.legendCollapsed,
        })
        map.addControl(legendCtrl)

        // add second legend so layers with legend_url will be bottom
        const legend2 = this.legend2 = new Legend({
            margin: 10,
            maxWidth: 400,
        })
        map.addControl(new LegendControl({
            legend: legend2,
            target: legendCtrl.element,
            className: 'legend2',
        }))

        // setTimeout(() => {
            for (const layer of map.getLayers().getArray()) {
                if (layer.get('legend_url')) { // only show legend if url saved
                    const layerLegend = new Legend({ layer })

                    layerLegend.addItem(new LegendImage({
                        title: layer.get('title'),
                        src: layer.get('legend_url'),
                    }))

                    legend2.addItem(layerLegend)
                }
            }
        // }, 50)
        this.$emit('legendMounted', {legend, legend2})
    },
    methods: {},
    render() {
        return null
    },
}
</script>

<style>
/*.ol-legend > canvas {
    float: left;
}*/
ul.ol-legend li.ol-title {
    text-align: left !important;
}

.ol-control.ol-legend:not(.ol-collapsed) {
    background-color: white !important;
}

.ol-legend > div.ol-legend {
    position: relative;
    top: -2px;
    left: 2px;
}
</style>
